/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AlertsRulesRouteImport } from './routes/alerts/rules'
import { Route as BlytzcollectAnalyticsRouteImport } from './routes/blytzcollect/analytics'
import { Route as CsToolsAutopayAccountsRouteImport } from './routes/cs-tools/autopay-accounts'
import { Route as CsToolsCollectionsScorecardRouteImport } from './routes/cs-tools/collections-scorecard'
import { Route as CsToolsCustomerListRouteImport } from './routes/cs-tools/customer-list'
import { Route as CsToolsMerchantNotesRouteImport } from './routes/cs-tools/merchant-notes'
import { Route as CsToolsMessageReportRouteImport } from './routes/cs-tools/message-report'
import { Route as CsToolsOptOutsRouteImport } from './routes/cs-tools/opt-outs'
import { Route as CsToolsPaymentReportRouteImport } from './routes/cs-tools/payment-report'
import { Route as CsToolsPropensityAccuracyRouteImport } from './routes/cs-tools/propensity-accuracy'
import { Route as CsToolsPropensityToPayRouteImport } from './routes/cs-tools/propensity-to-pay'
import { Route as CsToolsReconciliationRouteImport } from './routes/cs-tools/reconciliation'
import { Route as CsToolsRegistrationsRouteImport } from './routes/cs-tools/registrations'
import { Route as CsToolsUndeliveredRouteImport } from './routes/cs-tools/undelivered'
import { Route as LabReportChatRouteImport } from './routes/lab/report-chat'
import { Route as LabReportDraftRouteImport } from './routes/lab/report-draft'
import { Route as LabReportDraftsRouteImport } from './routes/lab/report-drafts'
import { Route as PaymentsAchReturnsRouteImport } from './routes/payments/ach-returns'
import { Route as PaymentsBinMccFeeReportRouteImport } from './routes/payments/bin-mcc-fee-report'
import { Route as PaymentsMulticardUsageRouteImport } from './routes/payments/multicard-usage'
import { Route as PaymentsRetryAnalysisRouteImport } from './routes/payments/retry-analysis'
import { Route as PlatformJobsRouteImport } from './routes/platform/jobs'
import { Route as ReportsAiDeclineImpactRouteImport } from './routes/reports/ai-decline-impact'
import { Route as ReportsAiDeclineJourneysRouteImport } from './routes/reports/ai-decline-journeys'
import { Route as ReportsAiTextsRouteImport } from './routes/reports/ai-texts'
import { Route as ReportsMerchantSettingsRouteImport } from './routes/reports/merchant-settings'
import { Route as SalesToolsPricingStudioRouteImport } from './routes/sales-tools/pricing-studio'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AlertsRulesRoute = AlertsRulesRouteImport.update({
  id: '/alerts/rules',
  path: '/alerts/rules',
  getParentRoute: () => rootRouteImport,
} as any)
const BlytzcollectAnalyticsRoute = BlytzcollectAnalyticsRouteImport.update({
  id: '/blytzcollect/analytics',
  path: '/blytzcollect/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsAutopayAccountsRoute = CsToolsAutopayAccountsRouteImport.update({
  id: '/cs-tools/autopay-accounts',
  path: '/cs-tools/autopay-accounts',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsCollectionsScorecardRoute =
  CsToolsCollectionsScorecardRouteImport.update({
    id: '/cs-tools/collections-scorecard',
    path: '/cs-tools/collections-scorecard',
    getParentRoute: () => rootRouteImport,
  } as any)
const CsToolsCustomerListRoute = CsToolsCustomerListRouteImport.update({
  id: '/cs-tools/customer-list',
  path: '/cs-tools/customer-list',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsMerchantNotesRoute = CsToolsMerchantNotesRouteImport.update({
  id: '/cs-tools/merchant-notes',
  path: '/cs-tools/merchant-notes',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsMessageReportRoute = CsToolsMessageReportRouteImport.update({
  id: '/cs-tools/message-report',
  path: '/cs-tools/message-report',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsOptOutsRoute = CsToolsOptOutsRouteImport.update({
  id: '/cs-tools/opt-outs',
  path: '/cs-tools/opt-outs',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsPaymentReportRoute = CsToolsPaymentReportRouteImport.update({
  id: '/cs-tools/payment-report',
  path: '/cs-tools/payment-report',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsPropensityAccuracyRoute =
  CsToolsPropensityAccuracyRouteImport.update({
    id: '/cs-tools/propensity-accuracy',
    path: '/cs-tools/propensity-accuracy',
    getParentRoute: () => rootRouteImport,
  } as any)
const CsToolsPropensityToPayRoute = CsToolsPropensityToPayRouteImport.update({
  id: '/cs-tools/propensity-to-pay',
  path: '/cs-tools/propensity-to-pay',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsReconciliationRoute = CsToolsReconciliationRouteImport.update({
  id: '/cs-tools/reconciliation',
  path: '/cs-tools/reconciliation',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsRegistrationsRoute = CsToolsRegistrationsRouteImport.update({
  id: '/cs-tools/registrations',
  path: '/cs-tools/registrations',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsUndeliveredRoute = CsToolsUndeliveredRouteImport.update({
  id: '/cs-tools/undelivered',
  path: '/cs-tools/undelivered',
  getParentRoute: () => rootRouteImport,
} as any)
const LabReportChatRoute = LabReportChatRouteImport.update({
  id: '/lab/report-chat',
  path: '/lab/report-chat',
  getParentRoute: () => rootRouteImport,
} as any)
const LabReportDraftRoute = LabReportDraftRouteImport.update({
  id: '/lab/report-draft',
  path: '/lab/report-draft',
  getParentRoute: () => rootRouteImport,
} as any)
const LabReportDraftsRoute = LabReportDraftsRouteImport.update({
  id: '/lab/report-drafts',
  path: '/lab/report-drafts',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsAchReturnsRoute = PaymentsAchReturnsRouteImport.update({
  id: '/payments/ach-returns',
  path: '/payments/ach-returns',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsBinMccFeeReportRoute = PaymentsBinMccFeeReportRouteImport.update({
  id: '/payments/bin-mcc-fee-report',
  path: '/payments/bin-mcc-fee-report',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsMulticardUsageRoute = PaymentsMulticardUsageRouteImport.update({
  id: '/payments/multicard-usage',
  path: '/payments/multicard-usage',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsRetryAnalysisRoute = PaymentsRetryAnalysisRouteImport.update({
  id: '/payments/retry-analysis',
  path: '/payments/retry-analysis',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformJobsRoute = PlatformJobsRouteImport.update({
  id: '/platform/jobs',
  path: '/platform/jobs',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsAiDeclineImpactRoute = ReportsAiDeclineImpactRouteImport.update({
  id: '/reports/ai-decline-impact',
  path: '/reports/ai-decline-impact',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsAiDeclineJourneysRoute =
  ReportsAiDeclineJourneysRouteImport.update({
    id: '/reports/ai-decline-journeys',
    path: '/reports/ai-decline-journeys',
    getParentRoute: () => rootRouteImport,
  } as any)
const ReportsAiTextsRoute = ReportsAiTextsRouteImport.update({
  id: '/reports/ai-texts',
  path: '/reports/ai-texts',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsMerchantSettingsRoute = ReportsMerchantSettingsRouteImport.update({
  id: '/reports/merchant-settings',
  path: '/reports/merchant-settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesToolsPricingStudioRoute = SalesToolsPricingStudioRouteImport.update({
  id: '/sales-tools/pricing-studio',
  path: '/sales-tools/pricing-studio',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/alerts/rules': typeof AlertsRulesRoute
  '/blytzcollect/analytics': typeof BlytzcollectAnalyticsRoute
  '/cs-tools/autopay-accounts': typeof CsToolsAutopayAccountsRoute
  '/cs-tools/collections-scorecard': typeof CsToolsCollectionsScorecardRoute
  '/cs-tools/customer-list': typeof CsToolsCustomerListRoute
  '/cs-tools/merchant-notes': typeof CsToolsMerchantNotesRoute
  '/cs-tools/message-report': typeof CsToolsMessageReportRoute
  '/cs-tools/opt-outs': typeof CsToolsOptOutsRoute
  '/cs-tools/payment-report': typeof CsToolsPaymentReportRoute
  '/cs-tools/propensity-accuracy': typeof CsToolsPropensityAccuracyRoute
  '/cs-tools/propensity-to-pay': typeof CsToolsPropensityToPayRoute
  '/cs-tools/reconciliation': typeof CsToolsReconciliationRoute
  '/cs-tools/registrations': typeof CsToolsRegistrationsRoute
  '/cs-tools/undelivered': typeof CsToolsUndeliveredRoute
  '/lab/report-chat': typeof LabReportChatRoute
  '/lab/report-draft': typeof LabReportDraftRoute
  '/lab/report-drafts': typeof LabReportDraftsRoute
  '/payments/ach-returns': typeof PaymentsAchReturnsRoute
  '/payments/bin-mcc-fee-report': typeof PaymentsBinMccFeeReportRoute
  '/payments/multicard-usage': typeof PaymentsMulticardUsageRoute
  '/payments/retry-analysis': typeof PaymentsRetryAnalysisRoute
  '/platform/jobs': typeof PlatformJobsRoute
  '/reports/ai-decline-impact': typeof ReportsAiDeclineImpactRoute
  '/reports/ai-decline-journeys': typeof ReportsAiDeclineJourneysRoute
  '/reports/ai-texts': typeof ReportsAiTextsRoute
  '/reports/merchant-settings': typeof ReportsMerchantSettingsRoute
  '/sales-tools/pricing-studio': typeof SalesToolsPricingStudioRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/alerts/rules': typeof AlertsRulesRoute
  '/blytzcollect/analytics': typeof BlytzcollectAnalyticsRoute
  '/cs-tools/autopay-accounts': typeof CsToolsAutopayAccountsRoute
  '/cs-tools/collections-scorecard': typeof CsToolsCollectionsScorecardRoute
  '/cs-tools/customer-list': typeof CsToolsCustomerListRoute
  '/cs-tools/merchant-notes': typeof CsToolsMerchantNotesRoute
  '/cs-tools/message-report': typeof CsToolsMessageReportRoute
  '/cs-tools/opt-outs': typeof CsToolsOptOutsRoute
  '/cs-tools/payment-report': typeof CsToolsPaymentReportRoute
  '/cs-tools/propensity-accuracy': typeof CsToolsPropensityAccuracyRoute
  '/cs-tools/propensity-to-pay': typeof CsToolsPropensityToPayRoute
  '/cs-tools/reconciliation': typeof CsToolsReconciliationRoute
  '/cs-tools/registrations': typeof CsToolsRegistrationsRoute
  '/cs-tools/undelivered': typeof CsToolsUndeliveredRoute
  '/lab/report-chat': typeof LabReportChatRoute
  '/lab/report-draft': typeof LabReportDraftRoute
  '/lab/report-drafts': typeof LabReportDraftsRoute
  '/payments/ach-returns': typeof PaymentsAchReturnsRoute
  '/payments/bin-mcc-fee-report': typeof PaymentsBinMccFeeReportRoute
  '/payments/multicard-usage': typeof PaymentsMulticardUsageRoute
  '/payments/retry-analysis': typeof PaymentsRetryAnalysisRoute
  '/platform/jobs': typeof PlatformJobsRoute
  '/reports/ai-decline-impact': typeof ReportsAiDeclineImpactRoute
  '/reports/ai-decline-journeys': typeof ReportsAiDeclineJourneysRoute
  '/reports/ai-texts': typeof ReportsAiTextsRoute
  '/reports/merchant-settings': typeof ReportsMerchantSettingsRoute
  '/sales-tools/pricing-studio': typeof SalesToolsPricingStudioRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/alerts/rules': typeof AlertsRulesRoute
  '/blytzcollect/analytics': typeof BlytzcollectAnalyticsRoute
  '/cs-tools/autopay-accounts': typeof CsToolsAutopayAccountsRoute
  '/cs-tools/collections-scorecard': typeof CsToolsCollectionsScorecardRoute
  '/cs-tools/customer-list': typeof CsToolsCustomerListRoute
  '/cs-tools/merchant-notes': typeof CsToolsMerchantNotesRoute
  '/cs-tools/message-report': typeof CsToolsMessageReportRoute
  '/cs-tools/opt-outs': typeof CsToolsOptOutsRoute
  '/cs-tools/payment-report': typeof CsToolsPaymentReportRoute
  '/cs-tools/propensity-accuracy': typeof CsToolsPropensityAccuracyRoute
  '/cs-tools/propensity-to-pay': typeof CsToolsPropensityToPayRoute
  '/cs-tools/reconciliation': typeof CsToolsReconciliationRoute
  '/cs-tools/registrations': typeof CsToolsRegistrationsRoute
  '/cs-tools/undelivered': typeof CsToolsUndeliveredRoute
  '/lab/report-chat': typeof LabReportChatRoute
  '/lab/report-draft': typeof LabReportDraftRoute
  '/lab/report-drafts': typeof LabReportDraftsRoute
  '/payments/ach-returns': typeof PaymentsAchReturnsRoute
  '/payments/bin-mcc-fee-report': typeof PaymentsBinMccFeeReportRoute
  '/payments/multicard-usage': typeof PaymentsMulticardUsageRoute
  '/payments/retry-analysis': typeof PaymentsRetryAnalysisRoute
  '/platform/jobs': typeof PlatformJobsRoute
  '/reports/ai-decline-impact': typeof ReportsAiDeclineImpactRoute
  '/reports/ai-decline-journeys': typeof ReportsAiDeclineJourneysRoute
  '/reports/ai-texts': typeof ReportsAiTextsRoute
  '/reports/merchant-settings': typeof ReportsMerchantSettingsRoute
  '/sales-tools/pricing-studio': typeof SalesToolsPricingStudioRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/alerts/rules'
    | '/blytzcollect/analytics'
    | '/cs-tools/autopay-accounts'
    | '/cs-tools/collections-scorecard'
    | '/cs-tools/customer-list'
    | '/cs-tools/merchant-notes'
    | '/cs-tools/message-report'
    | '/cs-tools/opt-outs'
    | '/cs-tools/payment-report'
    | '/cs-tools/propensity-accuracy'
    | '/cs-tools/propensity-to-pay'
    | '/cs-tools/reconciliation'
    | '/cs-tools/registrations'
    | '/cs-tools/undelivered'
    | '/lab/report-chat'
    | '/lab/report-draft'
    | '/lab/report-drafts'
    | '/payments/ach-returns'
    | '/payments/bin-mcc-fee-report'
    | '/payments/multicard-usage'
    | '/payments/retry-analysis'
    | '/platform/jobs'
    | '/reports/ai-decline-impact'
    | '/reports/ai-decline-journeys'
    | '/reports/ai-texts'
    | '/reports/merchant-settings'
    | '/sales-tools/pricing-studio'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/alerts/rules'
    | '/blytzcollect/analytics'
    | '/cs-tools/autopay-accounts'
    | '/cs-tools/collections-scorecard'
    | '/cs-tools/customer-list'
    | '/cs-tools/merchant-notes'
    | '/cs-tools/message-report'
    | '/cs-tools/opt-outs'
    | '/cs-tools/payment-report'
    | '/cs-tools/propensity-accuracy'
    | '/cs-tools/propensity-to-pay'
    | '/cs-tools/reconciliation'
    | '/cs-tools/registrations'
    | '/cs-tools/undelivered'
    | '/lab/report-chat'
    | '/lab/report-draft'
    | '/lab/report-drafts'
    | '/payments/ach-returns'
    | '/payments/bin-mcc-fee-report'
    | '/payments/multicard-usage'
    | '/payments/retry-analysis'
    | '/platform/jobs'
    | '/reports/ai-decline-impact'
    | '/reports/ai-decline-journeys'
    | '/reports/ai-texts'
    | '/reports/merchant-settings'
    | '/sales-tools/pricing-studio'
  id:
    | '__root__'
    | '/'
    | '/alerts/rules'
    | '/blytzcollect/analytics'
    | '/cs-tools/autopay-accounts'
    | '/cs-tools/collections-scorecard'
    | '/cs-tools/customer-list'
    | '/cs-tools/merchant-notes'
    | '/cs-tools/message-report'
    | '/cs-tools/opt-outs'
    | '/cs-tools/payment-report'
    | '/cs-tools/propensity-accuracy'
    | '/cs-tools/propensity-to-pay'
    | '/cs-tools/reconciliation'
    | '/cs-tools/registrations'
    | '/cs-tools/undelivered'
    | '/lab/report-chat'
    | '/lab/report-draft'
    | '/lab/report-drafts'
    | '/payments/ach-returns'
    | '/payments/bin-mcc-fee-report'
    | '/payments/multicard-usage'
    | '/payments/retry-analysis'
    | '/platform/jobs'
    | '/reports/ai-decline-impact'
    | '/reports/ai-decline-journeys'
    | '/reports/ai-texts'
    | '/reports/merchant-settings'
    | '/sales-tools/pricing-studio'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AlertsRulesRoute: typeof AlertsRulesRoute
  BlytzcollectAnalyticsRoute: typeof BlytzcollectAnalyticsRoute
  CsToolsAutopayAccountsRoute: typeof CsToolsAutopayAccountsRoute
  CsToolsCollectionsScorecardRoute: typeof CsToolsCollectionsScorecardRoute
  CsToolsCustomerListRoute: typeof CsToolsCustomerListRoute
  CsToolsMerchantNotesRoute: typeof CsToolsMerchantNotesRoute
  CsToolsMessageReportRoute: typeof CsToolsMessageReportRoute
  CsToolsOptOutsRoute: typeof CsToolsOptOutsRoute
  CsToolsPaymentReportRoute: typeof CsToolsPaymentReportRoute
  CsToolsPropensityAccuracyRoute: typeof CsToolsPropensityAccuracyRoute
  CsToolsPropensityToPayRoute: typeof CsToolsPropensityToPayRoute
  CsToolsReconciliationRoute: typeof CsToolsReconciliationRoute
  CsToolsRegistrationsRoute: typeof CsToolsRegistrationsRoute
  CsToolsUndeliveredRoute: typeof CsToolsUndeliveredRoute
  LabReportChatRoute: typeof LabReportChatRoute
  LabReportDraftRoute: typeof LabReportDraftRoute
  LabReportDraftsRoute: typeof LabReportDraftsRoute
  PaymentsAchReturnsRoute: typeof PaymentsAchReturnsRoute
  PaymentsBinMccFeeReportRoute: typeof PaymentsBinMccFeeReportRoute
  PaymentsMulticardUsageRoute: typeof PaymentsMulticardUsageRoute
  PaymentsRetryAnalysisRoute: typeof PaymentsRetryAnalysisRoute
  PlatformJobsRoute: typeof PlatformJobsRoute
  ReportsAiDeclineImpactRoute: typeof ReportsAiDeclineImpactRoute
  ReportsAiDeclineJourneysRoute: typeof ReportsAiDeclineJourneysRoute
  ReportsAiTextsRoute: typeof ReportsAiTextsRoute
  ReportsMerchantSettingsRoute: typeof ReportsMerchantSettingsRoute
  SalesToolsPricingStudioRoute: typeof SalesToolsPricingStudioRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/alerts/rules': {
      id: '/alerts/rules'
      path: '/alerts/rules'
      fullPath: '/alerts/rules'
      preLoaderRoute: typeof AlertsRulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blytzcollect/analytics': {
      id: '/blytzcollect/analytics'
      path: '/blytzcollect/analytics'
      fullPath: '/blytzcollect/analytics'
      preLoaderRoute: typeof BlytzcollectAnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/autopay-accounts': {
      id: '/cs-tools/autopay-accounts'
      path: '/cs-tools/autopay-accounts'
      fullPath: '/cs-tools/autopay-accounts'
      preLoaderRoute: typeof CsToolsAutopayAccountsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/collections-scorecard': {
      id: '/cs-tools/collections-scorecard'
      path: '/cs-tools/collections-scorecard'
      fullPath: '/cs-tools/collections-scorecard'
      preLoaderRoute: typeof CsToolsCollectionsScorecardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/customer-list': {
      id: '/cs-tools/customer-list'
      path: '/cs-tools/customer-list'
      fullPath: '/cs-tools/customer-list'
      preLoaderRoute: typeof CsToolsCustomerListRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/merchant-notes': {
      id: '/cs-tools/merchant-notes'
      path: '/cs-tools/merchant-notes'
      fullPath: '/cs-tools/merchant-notes'
      preLoaderRoute: typeof CsToolsMerchantNotesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/message-report': {
      id: '/cs-tools/message-report'
      path: '/cs-tools/message-report'
      fullPath: '/cs-tools/message-report'
      preLoaderRoute: typeof CsToolsMessageReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/opt-outs': {
      id: '/cs-tools/opt-outs'
      path: '/cs-tools/opt-outs'
      fullPath: '/cs-tools/opt-outs'
      preLoaderRoute: typeof CsToolsOptOutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/payment-report': {
      id: '/cs-tools/payment-report'
      path: '/cs-tools/payment-report'
      fullPath: '/cs-tools/payment-report'
      preLoaderRoute: typeof CsToolsPaymentReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/propensity-accuracy': {
      id: '/cs-tools/propensity-accuracy'
      path: '/cs-tools/propensity-accuracy'
      fullPath: '/cs-tools/propensity-accuracy'
      preLoaderRoute: typeof CsToolsPropensityAccuracyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/propensity-to-pay': {
      id: '/cs-tools/propensity-to-pay'
      path: '/cs-tools/propensity-to-pay'
      fullPath: '/cs-tools/propensity-to-pay'
      preLoaderRoute: typeof CsToolsPropensityToPayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/reconciliation': {
      id: '/cs-tools/reconciliation'
      path: '/cs-tools/reconciliation'
      fullPath: '/cs-tools/reconciliation'
      preLoaderRoute: typeof CsToolsReconciliationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/registrations': {
      id: '/cs-tools/registrations'
      path: '/cs-tools/registrations'
      fullPath: '/cs-tools/registrations'
      preLoaderRoute: typeof CsToolsRegistrationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/undelivered': {
      id: '/cs-tools/undelivered'
      path: '/cs-tools/undelivered'
      fullPath: '/cs-tools/undelivered'
      preLoaderRoute: typeof CsToolsUndeliveredRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lab/report-chat': {
      id: '/lab/report-chat'
      path: '/lab/report-chat'
      fullPath: '/lab/report-chat'
      preLoaderRoute: typeof LabReportChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lab/report-draft': {
      id: '/lab/report-draft'
      path: '/lab/report-draft'
      fullPath: '/lab/report-draft'
      preLoaderRoute: typeof LabReportDraftRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lab/report-drafts': {
      id: '/lab/report-drafts'
      path: '/lab/report-drafts'
      fullPath: '/lab/report-drafts'
      preLoaderRoute: typeof LabReportDraftsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/ach-returns': {
      id: '/payments/ach-returns'
      path: '/payments/ach-returns'
      fullPath: '/payments/ach-returns'
      preLoaderRoute: typeof PaymentsAchReturnsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/bin-mcc-fee-report': {
      id: '/payments/bin-mcc-fee-report'
      path: '/payments/bin-mcc-fee-report'
      fullPath: '/payments/bin-mcc-fee-report'
      preLoaderRoute: typeof PaymentsBinMccFeeReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/multicard-usage': {
      id: '/payments/multicard-usage'
      path: '/payments/multicard-usage'
      fullPath: '/payments/multicard-usage'
      preLoaderRoute: typeof PaymentsMulticardUsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/retry-analysis': {
      id: '/payments/retry-analysis'
      path: '/payments/retry-analysis'
      fullPath: '/payments/retry-analysis'
      preLoaderRoute: typeof PaymentsRetryAnalysisRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/jobs': {
      id: '/platform/jobs'
      path: '/platform/jobs'
      fullPath: '/platform/jobs'
      preLoaderRoute: typeof PlatformJobsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/ai-decline-impact': {
      id: '/reports/ai-decline-impact'
      path: '/reports/ai-decline-impact'
      fullPath: '/reports/ai-decline-impact'
      preLoaderRoute: typeof ReportsAiDeclineImpactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/ai-decline-journeys': {
      id: '/reports/ai-decline-journeys'
      path: '/reports/ai-decline-journeys'
      fullPath: '/reports/ai-decline-journeys'
      preLoaderRoute: typeof ReportsAiDeclineJourneysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/ai-texts': {
      id: '/reports/ai-texts'
      path: '/reports/ai-texts'
      fullPath: '/reports/ai-texts'
      preLoaderRoute: typeof ReportsAiTextsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/merchant-settings': {
      id: '/reports/merchant-settings'
      path: '/reports/merchant-settings'
      fullPath: '/reports/merchant-settings'
      preLoaderRoute: typeof ReportsMerchantSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales-tools/pricing-studio': {
      id: '/sales-tools/pricing-studio'
      path: '/sales-tools/pricing-studio'
      fullPath: '/sales-tools/pricing-studio'
      preLoaderRoute: typeof SalesToolsPricingStudioRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AlertsRulesRoute: AlertsRulesRoute,
  BlytzcollectAnalyticsRoute: BlytzcollectAnalyticsRoute,
  CsToolsAutopayAccountsRoute: CsToolsAutopayAccountsRoute,
  CsToolsCollectionsScorecardRoute: CsToolsCollectionsScorecardRoute,
  CsToolsCustomerListRoute: CsToolsCustomerListRoute,
  CsToolsMerchantNotesRoute: CsToolsMerchantNotesRoute,
  CsToolsMessageReportRoute: CsToolsMessageReportRoute,
  CsToolsOptOutsRoute: CsToolsOptOutsRoute,
  CsToolsPaymentReportRoute: CsToolsPaymentReportRoute,
  CsToolsPropensityAccuracyRoute: CsToolsPropensityAccuracyRoute,
  CsToolsPropensityToPayRoute: CsToolsPropensityToPayRoute,
  CsToolsReconciliationRoute: CsToolsReconciliationRoute,
  CsToolsRegistrationsRoute: CsToolsRegistrationsRoute,
  CsToolsUndeliveredRoute: CsToolsUndeliveredRoute,
  LabReportChatRoute: LabReportChatRoute,
  LabReportDraftRoute: LabReportDraftRoute,
  LabReportDraftsRoute: LabReportDraftsRoute,
  PaymentsAchReturnsRoute: PaymentsAchReturnsRoute,
  PaymentsBinMccFeeReportRoute: PaymentsBinMccFeeReportRoute,
  PaymentsMulticardUsageRoute: PaymentsMulticardUsageRoute,
  PaymentsRetryAnalysisRoute: PaymentsRetryAnalysisRoute,
  PlatformJobsRoute: PlatformJobsRoute,
  ReportsAiDeclineImpactRoute: ReportsAiDeclineImpactRoute,
  ReportsAiDeclineJourneysRoute: ReportsAiDeclineJourneysRoute,
  ReportsAiTextsRoute: ReportsAiTextsRoute,
  ReportsMerchantSettingsRoute: ReportsMerchantSettingsRoute,
  SalesToolsPricingStudioRoute: SalesToolsPricingStudioRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
